import React, { ReactElement, useRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Location } from 'history';
import { Switch, Route, useLocation } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { setLoading } from '../store/app-globals/actions';

import { Welcome } from './Welcome';
import { Authentication } from './auth/Authentication';
import { Dashboard } from './dashboard/Dashboard';
import { FilterForm } from './dashboard/FilterMeals';
import { CreateProfile } from './profile/CreateProfile';
import { UpdateProfile } from './profile/UpdateProfile';
import { Profile } from './profile/Profile';
import { EditProfile } from './profile/EditProfile';
import { BankAccount } from './bank/BankAccount';
import { Payment } from './bank/Payment';
import { AddPayment } from './bank/PaymentAddCard';
import { MyMeals } from './meals/Meals';
import { AddMeals } from './meals/AddMeals';
import { EditMeals } from './meals/EditMeals';
import { MyMealDetails } from './meals/components/MealDetails';
import { CookMealDetails } from './admin/components/MealDetails';
import { UserProfile } from './userprofile/profile';
import { Advertisement } from './admin/advertisement';
import {
  DesktopMealDetails,
  DesktopOrderDetails,
} from './desktop/NewMealDetails';
// import { MealDetails } from './userprofile/MealDetails';
import { Orders } from './orders/Orders';
// import { Details } from './orders/OrderDetails';
import { Chat } from './chat/Chat';
import { ChatMessage } from './chat/ChatDetails';
import { Settings } from './settings/Settings';
import { Admin } from './admin/admin';
import { ManageUser } from './admin/manageuser';
import { Offers } from './admin/Offers';
import { syncNotifications } from '../store/notifications/actions';
import { Notification } from './notification/Notifications';

import i18next from 'i18next';

// TODO: splash screen , welcome screen
const Page404: React.FC = () => <div>404</div>;

export const App: React.FC = (): ReactElement => {
  const location: Location = useLocation();

  const isFirstRender = useRef(true);
  const dispath = useDispatch();

  if (isFirstRender.current && location.pathname === '/') {
    dispath(setLoading(true, 'App is Loading'));
  }

  if (isFirstRender.current) {
    switch (i18next.language) {
      case 'en-US':
        i18next.changeLanguage('en');
        break;
      case 'cs-CZ':
        i18next.changeLanguage('cz');
        break;
      case 'cs':
        i18next.changeLanguage('cz');
        break;
      default:
    }
    dispath(syncNotifications());
  }

  // dispath(syncUser());
  isFirstRender.current = false;
  return (
    <div className="App">
      <TransitionGroup>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Switch location={location}>
            <Route exact path="/" component={Welcome} />
            <Route path="/authentication" component={Authentication} />

            <Route exact path="/dashboard" component={Dashboard} />
            <Route path="/dashboard/filter" component={FilterForm} />
            <Route exact path="/mymeals" component={MyMeals} />
            <Route path="/mymeals/create" component={AddMeals} />
            <Route path="/mymeals/:id" component={MyMealDetails} />
            <Route path="/meal/edit" component={EditMeals} />
            <Route exact path="/profile" component={Profile} />
            <Route path="/profile/create" component={CreateProfile} />
            <Route path="/profile/update" component={UpdateProfile} />
            <Route path="/profile/edit" component={EditProfile} />
            <Route exact path="/orders" component={Orders} />

            <Route exact path="/chat" component={Chat} />
            <Route path="/chat/:id" component={ChatMessage} />

            <Route path="/settings" component={Settings} />
            <Route path="/admin" component={Admin} />
            <Route path="/manageuser" component={ManageUser} />
            <Route path="/offers" component={Offers} />
            <Route path="/cookmeals/:id" component={CookMealDetails} />

            <Route path="/notifications" component={Notification} />
            <Route path="/advertisement" component={Advertisement} />

            <Route path="/bank" component={BankAccount} />
            <Route path="/userprofile/profile" component={UserProfile} />
            <Route exact path="/payment" component={Payment} />
            <Route path="/payment/add" component={AddPayment} />
            {/* DESKTOP COMPONENTS */}
            <Route path="/orderdetails" component={DesktopOrderDetails} />
            <Route path="/mealdetails" component={DesktopMealDetails} />
            <Route path="*" component={Page404} />
          </Switch>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};
